import { render, staticRenderFns } from "./creatorActive.vue?vue&type=template&id=7643beac&scoped=true"
import script from "./creatorActive.vue?vue&type=script&lang=js"
export * from "./creatorActive.vue?vue&type=script&lang=js"
import style0 from "./creatorActive.vue?vue&type=style&index=0&id=7643beac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7643beac",
  null
  
)

export default component.exports